import { useQuery } from "react-query";
import { fetcher } from "~/lib/misc";

export const getWorkoutByID = (workoutID) => async () => {
  const response = await fetcher(
    process.env.NEXT_PUBLIC_API_BASE_URL + "/workouts/" + workoutID,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return response;
};

export const useWorkout = (workoutID, initialData) => {
  const {
    data,
    dataUpdatedAt,
    error,
    errorUpdatedAt,
    failureCount,
    isError,
    isFetched,
    isFetchedAfterMount,
    isFetching,
    isIdle,
    isLoading,
    isLoadingError,
    isPlaceholderData,
    isPreviousData,
    isRefetchError,
    isRefetching,
    refetch,
    isStale,
    isSuccess,
    status,
  } = useQuery(
    workoutID && `workrout/${workoutID}`,
    getWorkoutByID(workoutID),
    {
      initialData,
    }
  );

  return {
    data,
    error,
    refetch,
    isLoading,
  };
};
